<form-card
  [titleText]="'Edit Pricing Template Name'"
  [submitButton]="true"
  [submitDisabled]="
    !editPricingTemplateNickNameForm.get('nameInput')?.value ||
    editPricingTemplateNickNameForm.get('nameInput')?.value.trim().length === 0 ||
    editPricingTemplateNickNameForm.get('nameInput')?.value.trim() === nickname?.trim()
  "
  [submitText]="'Save'"
  [backButton]="true"
  [backButtonText]="'Cancel'"
  [minWidth]=""
  [maxWidth]="'max-w-120'"
  (exitClick)="closeDialog()"
  (backClick)="closeDialog()"
  (submitClick)="saveEditPricingTemplateNickName()"
>
  <form [formGroup]="editPricingTemplateNickNameForm">
    <div class="mt-3">
      <tilled-input
        name="nameInput"
        label="Name"
        placeholder="Enter a Pricing Template Name"
        tilledLabel="true"
      ></tilled-input>
    </div>
  </form>
</form-card>
